export const GET_VISITORS_ANALYTICS = 'GET_VISITORS_ANALYTICS';
export const GET_TURNOVER_ANALYTICS = 'GET_TURNOVER_ANALYTICS';
export const GET_ADAPTATIONS_ANALYTICS = 'GET_ADAPTATIONS_ANALYTICS';
export const GET_DEMOGRAPHY_ANALYTICS = 'GET_DEMOGRAPHY_ANALYTICS';
export const GET_POSITIONS_ANALYTICS = 'GET_POSITIONS_ANALYTICS';
export const REPORT_SESSION = 'REPORT_SESSION';
export const GET_COINS_ANALYTICS = 'GET_COINS_ANALYTICS';
export const REPORT_MODULE_VISIT = 'REPORT_MODULE_VISIT';
export const GET_MODULE_ANALYTICS = 'GET_MODULE_ANALYTICS';